<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'BOATS-LIST' | translate}}</span>
        <div class="header-buttons">
        </div>
    </p-header>

    <form class="filters active" (submit)="find()">
        <div class="filter-row">
            <div class="form-control">
                <label for="boatName">{{'BOAT' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="boatFilter.boatName" name="boatName">
            </div>
            <div class="form-control">
                <label for="shipType">{{'TYPE' | translate}}</label>
                <p-multiSelect [options]="shipTypeOptions" [(ngModel)]="boatFilter.shipType" name="shipType"
                    appendTo="body" [defaultLabel]="'Selecione os tipos'" selectedItemsLabel="{0} tipos selecionados">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="shipType">{{'OWNER' | translate}}</label>
                <p-dropdown [options]="this.filteredCustomers" [filter]="true" [(ngModel)]="boatFilter.boatOwner" name="boatOwner"
                    appendTo="body">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="shipyardName">{{'SHIPYARD' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="boatFilter.shipyardName" name="shipyardName">
            </div>
            <div class="form-control">
                <label for="shipyardModelName">{{'MODEL' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="boatFilter.shipyardModelName" name="shipyardModelName">
            </div>
            <div class="form-control">
                <label for="tieRegister">{{'REGISTER' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="boatFilter.tieRegister" name="tieRegister">
            </div>
            <div class="form-control">
                <label for="expirationRange">{{'EXPIRATION-START' | translate}} / {{'EXPIRATION-END' | translate}}</label>
                <p-calendar dateFormat="dd/mm/yy" name="expirationRange" [monthNavigator]="true" appendTo="body"
                    [yearNavigator]="true" [yearRange]="'2019:2030'" selectionMode="range" rPCalendarMask [(ngModel)]="expirationRange"
                    [showIcon]="true" i18n>
                </p-calendar>
            </div>
            <div class="form-control">
                <label for="reviewed">{{'REVIEWED' | translate}}</label>
                <p-dropdown [(ngModel)]="boatFilter.reviewed" name="reviewed" appendTo="body"
                    [options]="[{label: 'Ambos', value: ''}, {label: 'Sim', value: true}, {label: 'Não', value: false}]">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="active">{{'STATUS' | translate}}</label>
                <p-dropdown [(ngModel)]="boatFilter.active" name="active" appendTo="body"
                    [options]="[{label: 'Ambos', value: ''}, {label: 'Ativo', value: true}, {label: 'Inativo', value: false}]">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="vacancy">{{'Vagas' | translate}}</label>
                <p-multiSelect [defaultLabel]="'Vagas'" [options]="vacancies" [(ngModel)]="boatFilter.vacanciesList"
                    appendTo="body" selectedItemsLabel="{0} itens selecionados" name="vacancy">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="boatProfile">{{'BOAT_PROFILE' | translate}}</label>
                <p-dropdown [(ngModel)]="boatFilter.boatProfile" name="boatProfile" appendTo="body" [options]="boatProfiles"></p-dropdown>
            </div>
            <div *ngIf="isMovements"  class="form-control">
                <label for='movementGroup'>{{'MOVEMENT_GROUP' | translate}}</label>
                <p-multiSelect [defaultLabel]="'Grupo de Movimentação'" appendTo="body"[(ngModel)]="boatFilter.movementGroup"
                [options]="movementGroupFormOptions" selectedItemsLabel="{0} itens selecionados" name="movementGroup"></p-multiSelect>
            </div>
            <div class="form-control" *ngIf="isFranchise">
                <label for="franchise">{{'Grupo de franquia' | translate}}</label>
                <p-multiSelect [defaultLabel]="'Grupo de Franquia'" [options]="franchiseGroupOptions" [(ngModel)]="boatFilter.franchiseGroup"
                    appendTo="body" selectedItemsLabel="{0} itens selecionados" name="franchise">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="boatProfile">{{'INSURER_EXPIRATION' | translate}}</label>
                <p-dropdown [(ngModel)]="boatFilter.insuranceExpiration" name="insuranceExpiration" appendTo="body" [options]="insuranceExpirationOptions"></p-dropdown>
            </div>
            <div class="form-control">
                <label for="dpemDateRange">{{'DPEM_EXPIRATION' | translate}}</label>
                <p-calendar 
                    dateFormat="dd/mm/yy" 
                    name="dpemDateRange" 
                    [monthNavigator]="true" 
                    appendTo="body"
                    [yearNavigator]="true" 
                    [yearRange]="'2020:2030'" 
                    selectionMode="range" 
                    [(ngModel)]="dpemDateRange"
                    [showIcon]="true"
                    [readonlyInput]="true">
                </p-calendar>
            </div>
            <div class="buttons">
              <p-button label="{{ 'CLEAR' | translate }}" styleClass="p-button-outlined p-button-secondary m-3" (click)="clear()"></p-button>
              <p-button label="Pesquisar" type="submit"></p-button>
            </div>
        </div>
    </form>

    <div class="table">
        <p-table #tt [value]="boats" [paginator]="true" [rows]="boatFilter.size" [lazy]="true" autoLayout="true"
            [columns]="cols" [totalRecords]="totalRecords" (onLazyLoad)="onChangePage($event)" styleClass="easy-table"
            [alwaysShowPaginator]="false" [selection]="selectedBoats">
            <ng-template pTemplate="caption">
                <div class="p-caption">
                    <p-splitButton
                    label="Embarcação"
                    icon="pi pi-plus"
                    [model]="items"
                    (onClick)="openBoatFormDialog()"
                  >
                  </p-splitButton>
                    <div class="totalizadores" style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap; gap: 1rem;">
                        <div class="total-registers-container">
                            <span class="total-registers">
                                {{ 'TOTAL-REGISTERS' | translate }}: {{boats.length}} {{'OF' | translate}} {{tt.totalRecords}}
                            </span>
                        </div>
                        <div>
                            <span *ngIf="marinaImplantation !== undefined && marinaImplantation !== null && marinaImplantation.totalBoatsActive">
                                Embarcações de Implantação: {{marinaImplantation.totalBoats}}
                            </span>
                        </div>
                        <div>
                            <span class="total-registers">
                                {{ 'BOATS-WITH-VALUE' | translate }}: {{boatsWithValue}}
                            </span>
                        </div>
                        <div>
                            <span class="total-registers">
                                {{ 'BOATS-TOTAL-VALUE' | translate }}: {{boatsTotalValue | dynamicCurrency: currentCurrency}}
                            </span>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th [pSortableColumn]="'name'">
                        {{ 'NAME' | translate }}
                        <p-sortIcon [field]="'name'"></p-sortIcon>
                    </th>
                    <th>{{ 'TYPE' | translate }}</th>
                    <th [pSortableColumn]="'shipyardName'">
                        {{ 'SHIPYARD' | translate }}
                        <p-sortIcon [field]="'shipyardName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'owners'">
                        {{ 'OWNERS' | translate }}
                        <p-sortIcon [field]="'owners'"></p-sortIcon>
                    </th>
                    <th>
                        Contato
                    </th>
                    <th [pSortableColumn]="'policyExpirationDate'">
                        {{ 'INSURANCE_EXPIRATION_SHORT' | translate }}
                        <p-sortIcon [field]="'policyExpirationDate'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'policyDpemExpirationDate'">
                        {{ 'DPEM_EXPIRATION_SHORT' | translate }}
                        <p-sortIcon [field]="'policyDpemExpirationDate'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'shipyardModelName'">
                        {{ 'MODEL' | translate }}
                        <p-sortIcon [field]="'shipyardModelName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'tieExpiration'">
                        {{ 'EXPIRATION' | translate }}
                        <p-sortIcon [field]="'tieExpiration'"></p-sortIcon>
                    </th>
                    <th *ngIf="isMovements && false">
                      {{ 'QUEUEUP' | translate }}
                    </th>
                    <th [pSortableColumn]="'boatProfile'">
                        {{'BOAT_PROFILE' | translate}}
                        <p-sortIcon [field]="'boatProfile'"></p-sortIcon>
                    </th>
                    <th *ngIf="isMovements"  [pSortableColumn]="'movementGroup'">
                        {{'MOVEMENT_GROUP' | translate}}
                        <p-sortIcon [field]="'movementGroup'"></p-sortIcon>
                    </th>
                    <!-- <th [pSortableColumn]="'idMovementLocation'">
                        {{ 'LOCATION' | translate }}
                        <p-sortIcon [field]="'movementLocation.id'"></p-sortIcon>

                    </th> -->
                    <th *ngIf="isMovements" >
                        {{ 'LOCATION' | translate }}
                    </th>
                    <th *ngIf="isFranchise">
                        {{'Grupo de franquia' | translate}}
                    </th>
                    <th [pSortableColumn]="'codeVacancy'">
                        {{ 'VACANCY' | translate }}
                        <p-sortIcon [field]="'vacancy.code'"></p-sortIcon>
                    </th>
                    <th class="text-center" width="8%" [pSortableColumn]="'reviewed'">
                        {{ 'REVIEWED' | translate }}
                        <p-sortIcon [field]="'reviewed'"></p-sortIcon>
                    </th>
                    <th class="text-center" width="6%" [pSortableColumn]="'active'">
                        {{ 'STATUS' | translate }}
                        <p-sortIcon [field]="'active'"></p-sortIcon>
                    </th>
                    <th>{{ 'ACTIONS' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-boat>
                <tr [ngClass]="{'em-alert': isDocumentExpired(boat)}">
                    <td>{{boat.name}}</td>
                    <td>{{boat.shipTypeBoat}}</td>
                    <td>{{boat.shipyardName}}</td>
                    <td *ngIf="boat.qtdOwners == 1 || boat.qtdOwners == null">{{boat.owners}}</td>
                    <td *ngIf="boat.qtdOwners > 1" [pTooltip]="boat.owners">Diversos</td>

                    <td *ngIf="boat.qtdOwners == 1 || boat.qtdOwners == null">{{boat.contact}}</td>
                    <td *ngIf="boat.qtdOwners > 1" [pTooltip]="boat.contact">Diversos</td>
                    <td>{{boat.boatInsurerExpirationDate | date: 'dd/MM/yy'}}</td>
                    <td>
                        <span *ngIf="boat.dpem && boat.dpem.policyDpemExpirationDate" 
                              (click)="openDpemDialog(boat.dpem)" 
                              style="cursor: pointer;">
                            {{boat.dpem.policyDpemExpirationDate | date: 'dd/MM/yy'}}
                        </span>
                        <span *ngIf="!boat.dpem || !boat.dpem.policyDpemExpirationDate">-</span>
                    </td>
                    <td>{{boat.shipyardModelName}}</td>
                    <td>{{boat.tieExpiration | date: 'dd/MM/yy'}}</td>
                    <td *ngIf="isMovements && false">
                      <app-boat-movement-group
                        [params]="{name: boat?.movementGroup?.name,
                          urlIcon:  boat?.movementGroup?.urlIcon}">
                      </app-boat-movement-group>
                    </td>
                    <td>{{boat.boatProfile }}</td>
                    <td *ngIf="isMovements" >{{boat.movementGroup }}</td>
                    <td *ngIf="isMovements" >{{boat?.movementLocation?.name}}</td>
                    <td *ngIf="isFranchise">{{boat?.franchiseGroup?.name}}</td>
                    <td class="table-dropdown">
                        <p-dropdown [style]="{'width': '100%'}" [options]="getOptionsVacancies(boat)" appendTo="body"
                            [(ngModel)]="boat.vacancy" dataKey="id" [name]="boat + boats.indexOf(boat)"
                            (onChange)="changeVacancy(boat)">
                        </p-dropdown>
                    </td>
                    <td class="text-center">
                        <span *ngIf="boat.reviewed" class="pi pi-check-circle" style="color: rgb(34, 162, 34); font-size: 1.5rem;" 
                              [pTooltip]="'Revisado'" tooltipPosition="bottom" (click)="updateReviewed(boat)"></span>
                        <span *ngIf="!boat.reviewed" class="pi pi-times-circle" style="color: rgb(176, 66, 66); font-size: 1.5rem;" 
                              [pTooltip]="'Não Revisado'" tooltipPosition="bottom" (click)="updateReviewed(boat)"></span>
                    </td>
                    <td class="text-center">
                        <div style="position: relative; display: inline-block;">
                            <p-inputSwitch [(ngModel)]="boat.active"></p-inputSwitch>
                            <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer; z-index: 1;" 
                                 [pTooltip]="boat.active ? 'Status Ativo' : 'Status Inativo'" tooltipPosition="bottom"
                                 (click)="confirmStatusChange($event, boat)"></div>
                        </div>
                    </td>
                    <td>
                        <p-menu appendTo="body" #menu [model]="menuItems" [popup]="true" [showTransitionOptions]="'150ms'" 
                            [hideTransitionOptions]="'150ms'"></p-menu>
                        <button (click)="menu.toggle($event); changeSelectedItem(boat)" pButton type="button"
                            icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded p-button-lg"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>

<p-dialog [(visible)]="displayDpemDialog" [modal]="true" [style]="{width: '80vw', height: '90vh'}" 
          [baseZIndex]="10000" [draggable]="false" [resizable]="false" header="Documento DPEM">
    <div style="display: flex; justify-content: center; align-items: center; height: 100%; overflow: auto;">
        <img *ngIf="selectedDpemFile" [src]="selectedDpemFile" alt="DPEM Document" 
             style="max-width: 100%; max-height: 100%; object-fit: contain;">
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Fechar" icon="pi pi-times" (click)="displayDpemDialog = false" styleClass="p-button-text"></p-button>
        <a *ngIf="selectedDpemFile" [href]="selectedDpemFile" target="_blank" download>
            <p-button label="Baixar" icon="pi pi-download"></p-button>
        </a>
    </ng-template>
</p-dialog>
